

import ReactLoading from 'react-loading';
export function LoadingBubble() {
    return (<div className=" d-flex justify-content-center align-items-center" style={{ height: 700 }}>
        <ReactLoading className="align-middle" type={"spin"} color={"#FFA202"} height={60} width={60} />
    </div>);
}